module.exports = __webpack_public_path__ + "img/uk-events-4.cad1571e.png";